import React from 'react'

const About = () => {
    return (
        <>


            {/* BANNER */}
            <section>
                <div className="str">
                    <div className="ban-inn ab-ban">
                        <div className="container">
                            <div className="row">
                                <div className="hom-ban">
                                    <div className="ban-tit">
                                        <span>
                                            <i className="no1">#1</i> Wedding Website
                                        </span>
                                        <h1>About us</h1>
                                        <p>Most Trusted and premium Matrimony Service in the World.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}
            {/* START */}
            <section>
                <div className="ab-sec2">
                    <div className="container">
                        <div className="row">
                            <ul>
                                <li>
                                    <div>
                                        <img src="images/icon/prize.png" alt="" />
                                        <h4>Genuine profiles</h4>
                                        <p>The most trusted wedding matrimony brand</p>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <img src="images/icon/trust.png" alt="" />
                                        <h4>Most trusted</h4>
                                        <p>The most trusted wedding matrimony brand</p>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <img src="images/icon/rings.png" alt="" />
                                        <h4>2000+ weddings</h4>
                                        <p>The most trusted wedding matrimony brand</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}
            {/* START */}
            <section>
                <div className="ab-wel">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="ab-wel-lhs">
                                    <span className="ab-wel-3" />
                                    <img src="https://i.pinimg.com/736x/97/ea/b7/97eab71f1886407bd6a561673d2aec11.jpg" alt="" className="ab-wel-1" />
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ_aGIujjPC2FGwc6yuguphDUYSUnb3cTtZTH925ZqK_WdOUZrUOMrTvQBVEsXjcLCB9qI&usqp=CAU" alt="" className="ab-wel-2" />
                                    <span className="ab-wel-4" />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="ab-wel-rhs">
                                    <div className="ab-wel-tit">
                                        <h2>
                                            Welcome to <em>Wedding matrimony</em>
                                        </h2>
                                        <p>
                                            Best wedding matrimony It is a long established fact that a
                                            reader will be distracted by the readable content of a page
                                            when looking at its layout.{" "}
                                        </p>
                                        {/* <p>
                                            {" "}
                                            <a href="plans.html">Click here to</a> Start you matrimony
                                            service now.
                                        </p> */}
                                    </div>
                                    <div className="ab-wel-tit-1">
                                        <p>
                                            There are many variations of passages of Lorem Ipsum
                                            available, but the majority have suffered alteration in some
                                            form, by injected humour, or randomised words which don't look
                                            even slightly believable.
                                        </p>
                                    </div>
                                    <div className="ab-wel-tit-2">
                                        <ul>
                                            <li>
                                                <div>
                                                    <i className="fa fa-phone" aria-hidden="true" />
                                                    <h4>
                                                        Enquiry <em>91 044 2432 2858</em>
                                                    </h4>
                                                </div>
                                            </li>
                                            <li>
                                                <div>
                                                    <i className="fa fa-envelope-o" aria-hidden="true" />
                                                    <h4>
                                                        Get Support <em> admin@cnnmandram.com</em>
                                                    </h4>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}
            {/* START */}
            <section>
                <div className="ab-cont">
                    <div className="container">
                        <div className="row">
                            <ul>
                                <li>
                                    <div className="ab-cont-po">
                                        <i className="fa fa-heart-o" aria-hidden="true" />
                                        <div>
                                            <h4>20K</h4>
                                            <span>Couples pared</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="ab-cont-po">
                                        <i className="fa fa-users" aria-hidden="true" />
                                        <div>
                                            <h4>99999+</h4>
                                            <span>Registered users</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="ab-cont-po">
                                        <i className="fa fa-male" aria-hidden="true" />
                                        <div>
                                            <h4>40000+</h4>
                                            <span>Mens</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="ab-cont-po">
                                        <i className="fa fa-female" aria-hidden="true" />
                                        <div>
                                            <h4>40000+</h4>
                                            <span>Womens</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            {/* END */}

            {/* START */}

            {/* END */}
            {/* START */}


        </>

    )
}

export default About